export const isAuthenticated = (state) => {
  console.log(state, "reducer");
  if (state.auth.auth.idToken) {
    return true;
  }
  return false;
};
